(function () {
    'use strict';

    var core = angular.module('app.core');

    core.config(toastrConfig);

    toastrConfig.$inject = ['toastr'];
    /* @ngInject */
    function toastrConfig(toastr) {
        toastr.options.timeOut = 4000;
        toastr.options.positionClass = 'toast-bottom-left';
    }

    var config = {
        appErrorPrefix: '[Account Management System Error] ',
        appTitle: 'Account Management System',
        apiUrl: window.siteBaseUrl + 'api/',
        sharedDataApiUrl: window.sharedDataApiUrl + '/',
        portalCDNApiUrl: window.portalCDNUrl + '/',
        auth0Domain: window.Auth0Domain,
        isDebuggingEnabled: window.IsDebuggingEnabled,
        hereMaps: {
            apiKey: window.hereAPIKey,
            geoCodeUrl: window.hereGeocoderUrl,
            autoCompleteUrl: window.hereAutoCompleteUrl
        }
    };

    core.value('config', config);

    core.config(configure);

    /* @ngInject */
    function configure($logProvider,
        routerHelperProvider,
        exceptionHandlerProvider,
        formlyProvider,
        $breadcrumbProvider,
        $qProvider, $provide) {

        if ($logProvider.debugEnabled) {
            $logProvider.debugEnabled(config.isDebuggingEnabled);
        }
        exceptionHandlerProvider.configure(config.appErrorPrefix);
        routerHelperProvider.configure({ docTitle: config.appTitle + ': ' });
        formlyProvider.configure();
        $breadcrumbProvider.setOptions({
            prefixStateName: null,
            includeAbstract: true,
            template: 'bootstrap3'
        });
        $qProvider.errorOnUnhandledRejections(false);

        var mapValues = function (obj, callback) {
            if (angular.isArray(obj)) {
                return obj.map(callback);
            }

            var ret = {};
            Object.keys(obj).forEach(function (key, val) {
                ret[key] = callback(obj[key], key);
            });

            return ret;
        };

        $provide.decorator('$q', ['$delegate', function ($delegate) {
            var $q = $delegate;

            $q.allSettled = function (promises) {
                return $q.all(mapValues(promises, function (promiseOrValue) {
                    if (!promiseOrValue.then) {
                        return { state: 'fulfilled', value: promiseOrValue };
                    }

                    return promiseOrValue.then(function (value) {
                        return { state: 'fulfilled', value: value };
                    }, function (reason) {
                        return { state: 'rejected', reason: reason };
                    });
                }));
            };

            $q.map = function (values, callback) {
                return $q.all(mapValues(values, callback));
            };

            $q.mapSettled = function (values, callback) {
                return $q.allSettled(mapValues(values, callback));
            };

            if (!$q.resolve) {
                $q.resolve = function (value) {
                    if (value && value.then) {
                        return value;
                    }
                    else {
                        return $q(function (resolve) { resolve(value); });
                    }
                };
            }

            return $q;
        }]);

    }
    core.run(run);

    /* @ngInject */
    function run(formlyService) {
        formlyService.initFormly();
    }    
})();
